module.exports = __webpack_public_path__ + "static/img/plan2.efc74ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/plans/zombs/plan2.png
// module id = HM8X
// module chunks = 38